// extracted by mini-css-extract-plugin
module.exports = {"sliderButlletins":"sliderbutlletins_sliderButlletins__Q_teN"};